module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2022-10-18 at 12.39.28 PM (1).71a6bbdc.jpeg";